export default "__VITE_ASSET__01ff2865__"